import { routes } from './routes';
import OblViaturas from './viaturas/index';
import OblArmazens from './armazem/index.js';
import OblProdutos from './produtos/index.js';
import Obler2_5 from './2.5/index.ts';
import OblCalendarizacaoController from './calendarizacao/controller';
import OblClientesListController from './clientes/list/controller';
import OblClientesDetailsController from './clientes/details/controller';
export default angular
    .module('app.obler', [OblViaturas, OblArmazens, OblProdutos, Obler2_5])
    .config(routes)
    .controller('OblClientesListController', OblClientesListController)
    .controller('OblCalendarizacaoController', OblCalendarizacaoController)
    .controller('OblClientesDetailsController', OblClientesDetailsController).name;
